import React from "react";
import "./featuresDropDown.css";
import FeaturesDropDownOption from "./FeaturesDropDownOption";

const FeaturesDropDown = ({ isMobile, showDropDown, showMobileDropDown }) => {
  return (
    <div
      className={`drop-down-menu features-menu-card ${
        showDropDown === 3 ? "drop-down-menu-show" : ""
      } ${isMobile ? "mobile-dropDown" : ""} ${
        showMobileDropDown === 3 ? " mobile-dropDown-show" : ""
      }`}
    >
      <img src="./images/menu-icons/triangle.svg" className="tip" alt="" />
      <div className="row drop-down-options px-3 py-4 features-options">
        <div className="p-0">
          <FeaturesDropDownOption
            icon="./images/menu-icons/calender.svg"
            title="Calender"
            details="A versatile Scheduler that always stay upto date"
            pageLink="/calendar"
          />
          <FeaturesDropDownOption
            icon="./images/menu-icons/online booking.svg"
            title="Online Booking"
            details="A versatile Scheduler that always stay upto date"
            pageLink="/online-booking"
          />
          <FeaturesDropDownOption
            icon="./images/menu-icons/payments.svg"
            title="Payments"
            details="A versatile Scheduler that always stay upto date"
            pageLink="/card-processing"
            New={true}
          />
          <FeaturesDropDownOption
            icon="./images/menu-icons/notification.svg"
            title="Notifications"
            details="A versatile Scheduler that always stay upto date"
            pageLink="/notifications"
          />
          <FeaturesDropDownOption
            icon="./images/menu-icons/customer tracking.svg"
            title="Customer Tracking"
            details="A versatile Scheduler that always stay upto date"
            pageLink="/customer-tracking"
          />
          <FeaturesDropDownOption
            icon="./images/menu-icons/forms.svg"
            title="Forms"
            details="A versatile Scheduler that always stay upto date"
            pageLink="/forms"
          />
          <FeaturesDropDownOption
            icon="./images/menu-icons/markiting.svg"
            title="Marketing"
            details="A versatile Scheduler that always stay upto date"
            pageLink="/marketing"
            New={true}
          />
          <FeaturesDropDownOption
            icon="./images/menu-icons/cart.svg"
            title="Market Place"
            details="A versatile Scheduler that always stay upto date"
            pageLink="/marketplace"
          />
          <FeaturesDropDownOption
            icon="./images/menu-icons/store.svg"
            title="Online Store"
            details="A versatile Scheduler that always stay upto date"
            pageLink="/online-store"
          />
          <FeaturesDropDownOption
            icon="./images/menu-icons/camera.svg"
            title="Live Stream"
            details="A versatile Scheduler that always stay upto date"
            pageLink="/live-stream-classes"
            New={true}
          />
          <FeaturesDropDownOption
            icon="./images/menu-icons/invoice.svg"
            title="Invoices"
            details="A versatile Scheduler that always stay upto date"
            pageLink="/invoices"
          />
          <FeaturesDropDownOption
            icon="./images/menu-icons/inventory.svg"
            title="Inventory"
            details="A versatile Scheduler that always stay upto date"
            pageLink="/inventory"
          />
          <FeaturesDropDownOption
            icon="./images/menu-icons/membership.svg"
            title="Memberships"
            details="A versatile Scheduler that always stay upto date"
            pageLink="/memberships"
          />
          <FeaturesDropDownOption
            icon="./images/menu-icons/payroll.svg"
            title="Payroll"
            details="A versatile Scheduler that always stay upto date"
            pageLink="/payroll"
          />
          <FeaturesDropDownOption
            icon="./images/menu-icons/rent.svg"
            title="Rent & Fees"
            details="A versatile Scheduler that always stay upto date"
            pageLink="/automatic-rent-fees"
            New={true}
          />
          <FeaturesDropDownOption
            icon="./images/menu-icons/bapp.svg"
            title="Branded App"
            details="A versatile Scheduler that always stay upto date"
            pageLink="/branded-app"
          />
          <FeaturesDropDownOption
            icon="./images/menu-icons/reports.svg"
            title="Reports"
            details="A versatile Scheduler that always stay upto date"
            pageLink="/reports"
          />
          <FeaturesDropDownOption
            icon="./images/menu-icons/paydesk.svg"
            title="Pay Desk (POS)"
            details="A versatile Scheduler that always stay upto date"
            pageLink="/vagaro-pay-desk"
          />
          <FeaturesDropDownOption
            icon="./images/menu-icons/mobile.svg"
            title="Mobile Apps"
            details="A versatile Scheduler that always stay upto date"
            pageLink="/vagaro-app"
          />
          <FeaturesDropDownOption
            icon="./images/menu-icons/web builder.svg"
            title="Website Builder"
            details="A versatile Scheduler that always stay upto date"
            pageLink="/website"
          />
        </div>
      </div>
    </div>
  );
};

export default FeaturesDropDown;
